import { render, staticRenderFns } from "./WowClassicComponent.vue?vue&type=template&id=4488469f&"
import script from "./WowClassicComponent.vue?vue&type=script&lang=js&"
export * from "./WowClassicComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports